import { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import {
  MediaQueryComputer,
  MediaQueryMobile,
  MediaQueryTablet,
} from '../../Constants';

type Screens = 'mobile' | 'tablet' | 'computer';

function useScreenType(screenType: Screens) {
  const queryType = useMemo(() => {
    switch (screenType) {
      case 'tablet':
        return MediaQueryTablet;
      case 'computer':
        return MediaQueryComputer;
      default:
        return MediaQueryMobile;
    }
  }, []);

  const isScreenType = useMediaQuery({ query: queryType });

  return isScreenType;
}

export default useScreenType;
